import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { miEnvironment } from '../mobile-instructions-environment';
import { StatusSearchRequest } from '../models/status-search-request';
import { mobileInstructionStatusSchema } from '../schemas/mobile-instruction-status.schema';

/**
 * Searches for instructions based on passed in parameters including status
 * @param searchRequest The parameters specifying which instructions to search for
 * @returns The searched for instructions
 */
export function postInstructionStatusSearch(
  this: unknown,
  statusSearchRequest: Partial<StatusSearchRequest>
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(miEnvironment.resolve(this).instructionStatusSearchUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(statusSearchRequest),
      })
    )
  ).pipe(selectData(z.array(mobileInstructionStatusSchema)));
}
